<template>
    <div class="sub-record-list">
        <div class="sub-record-opration">

            <div style="display: inline-block;margin-right: 10px">
                <span>付费类型:</span>
                <el-select v-model="queryParams.payType" placeholder="类型">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="用户支付" :value="1"></el-option>
                    <el-option label="自动续费" :value="2"></el-option>
                </el-select>
            </div>

            <div style="display: inline-block;margin-right: 10px">
                <span>订阅类型:</span>
                <el-select v-model="queryParams.isFree" placeholder="类型">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="免费订阅" :value="1"></el-option>
                    <el-option label="付费订阅" :value="0"></el-option>
                </el-select>
            </div>

            <el-date-picker style="margin-bottom: 10px"
                            v-model="dataArr"
                            type="datetimerange"
                            value-format="timestamp"
                            range-separator="至"
                            start-placeholder="订阅付费开始日期"
                            end-placeholder="订阅付费结束日期">
            </el-date-picker>

            <el-input placeholder="请输入订单ID" clearable v-model="queryParams.id" style="width: 350px">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>

            <el-button style="margin-left: 10px" type="danger" @click="searchSubHistory">搜索</el-button>

        </div>
        <div class="sub-record-list">
            <el-table class="sub-record-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="dataList" :row-key="() => Math.random()">
                <el-table-column prop="id" label="记录ID" show-overflow-tooltip></el-table-column>
                <el-table-column prop="strategyId" label="策略ID" show-overflow-tooltip></el-table-column>
                <el-table-column prop="strategyName" label="策略名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="coinType" label="付费币种" show-overflow-tooltip></el-table-column>
                <el-table-column prop="userId" label="订阅用户id" show-overflow-tooltip></el-table-column>
                <el-table-column prop="subBuyType" label="订阅套餐" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.subBuyType == 1">1个月</span>
                        <span v-if="scope.row.subBuyType == 2">3个月</span>
                        <span v-if="scope.row.subBuyType == 3">连续包月</span>
                    </template>
                </el-table-column>
                <el-table-column prop="payType" label="支付类型" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.payType == 1">用户支付</span>
                        <span v-if="scope.row.payType == 2">自动续费</span>
                    </template>
                </el-table-column>
                <el-table-column prop="isFree" label="是否免费" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.isFree == 0">付费</span>
                        <span v-if="scope.row.isFree == 1">免费</span>
                    </template>
                </el-table-column>
                <el-table-column prop="subPrice" label="付费金额" show-overflow-tooltip></el-table-column>
                <el-table-column label="付费时间" width="200">
                    <template slot-scope="scope">
                        <span>{{scope.row.createDate | moment}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';

    export default {
        name: "SubRecord",
        data() {
            return {
                dataList: [], //数据列表
                total: 0, //总条数
                queryParams: { //查询参数
                    id: "",
                    isFree: "",
                    payType: "",
                    startTime: "",
                    endTime: "",
                    page: 1,
                    size: 10
                },
                typeList: [
                    {label: '策略名称', value: 0},
                    {label: '订阅用户ID', value: 1},
                ],
                dataArr: []
            }
        },
        computed: {},
        mounted() {
        },
        methods: {
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getSubHistory(this.queryParams);
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getSubHistory(this.queryParams);
            },
            getSubHistory(param) {
                // console.log(this.dataArr)
                if (this.dataArr != null && this.dataArr.length > 0) {
                    param.startTime = this.dataArr[0];
                    param.endTime = this.dataArr[1];
                }
                api.getSubHistory(param).then(({data}) => {
                    this.dataList = data.data;
                    this.total = data.total;
                });
            },
            searchSubHistory() {
                this.queryParams.page = 1;
                this.getSubHistory(this.queryParams);
            }
        },
        created() {
            this.getSubHistory(this.queryParams);
        }
    }
</script>


<style type="text/css">
    .sub-record-list .el-tabs__nav-wrap::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 2px;
        background-color: rgba(245, 249, 255, 0);
        z-index: 1;
    }
</style>
<style lang="less" scoped>
    .sub-record-list {

        .sub-record-list {
            border: 1px solid #f2ece2;
            clear: both;
            width: 100%;
            .sub-record-table {
                margin-top: 30px;

                .red {
                    color: #EC6D56;
                }
                .blue {
                    color: #406CE9;
                }
                .green {
                    color: #6dec82;
                }
            }
        }
    }
</style>